export default __webpack_public_path__ + "static/media/preset_original.00b1faab.jpg";